import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { tracked } from '@glimmer/tracking';

import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Button from 'umg-ember-backend/components/ui/button';
import Form from 'umg-ember-backend/components/ui/form';
import InfoBox from 'umg-ember-backend/components/ui/info-box';

export default class RecordDetailFormsMlpCountdownComponent extends Component {
  // Defaults
  @tracked instructionAccepted = false;

  // Functions
  acceptInstruction = () => {
    this.instructionAccepted = true;
  };

  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='end' @type='date-time' />
            <fieldset.field @property='format' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset
            @titleKey='newsletter'
            @isVisible={{true}}
            as |fieldset|
          >
            {{#if (or @model.newsletter this.instructionAccepted)}}
              <fieldset.field
                @property='newsletter'
                @type='belongs-to'
                @on={{hash openRecordList=false}}
              />

              <fieldset.field @property='newsletterText' />
            {{else}}
              <InfoBox @type='warning'>
                {{t 'record_detail.forms.mlp_countdown.newsletter.instruction'}}
                <br />
                <br />
                <Button
                  @label={{t
                    'record_detail.forms.mlp_countdown.newsletter.accept'
                  }}
                  {{on 'click' this.acceptInstruction}}
                />
              </InfoBox>
            {{/if}}
          </form.fieldset>
        </div>
      </div>
    </Form>
  </template>
}
